import { Component, Vue } from 'vue-property-decorator';

@Component({
    metaInfo() {
        return {
            title: 'Home',
        };
    },
})
export default class Home extends Vue {
    document: any = null;

    async created() {
        this.document = await this.$prismic.client.getSingle('homepage');
    }
}
